// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"426":"audit","637":"order","907":"announcement","930":"task"}[chunkId] || chunkId) + "." + {"286":"7470ec9e","426":"34732c36","592":"6f1e129c","637":"40e162cf","660":"0e49c648","871":"fa3984f8","907":"3bf1ebba","930":"956d27be"}[chunkId] + ".js";
};